<div [ngClass]="{ 'no-icon': !icon }">
  <img *ngIf="icon" [src]="icon" alt=""/>
  <h2>{{ label }}</h2>
  <p>{{ content }}</p>
  <div class="actions">
    <ng-content></ng-content>
  </div>
</div>
